import { SET_NOTIFICATION, SET_ERROR_NOTIFICATION, REMOVE_NOTIFICATION_MUTATION } from './mutation-types'

export default {
	[SET_NOTIFICATION] (state, notification) {
		state.notifications = [notification, ...state.notifications]
	},

	[SET_ERROR_NOTIFICATION] (state, notification) {
		state.notifications = [notification, ...state.notifications]
	},

	[REMOVE_NOTIFICATION_MUTATION] (state, notificationId) {
		state.notifications = state.notifications.filter(n => n.id !== notificationId)
	}
}
